import { Component, Input } from "@angular/core";

export interface TimesheetTag {
  type: TimesheetTagType;
  date: Date | string;
}

export enum TimesheetTagType {
  ATTESTATION = "attestation", // Atestado
  ALLOWANCE = "allowance", // Abono
}

@Component({
  selector: "app-timesheet-tags",
  templateUrl: "./timesheet-tags.component.html",
  styleUrls: ["./timesheet-tags.component.scss"],
})
export class TimesheetTagsComponent {
  @Input() tags: TimesheetTag[] = [];

  tagType = TimesheetTagType;
}

